import axios from 'axios';

/** Force https for production API host; keep localhost on http */
export const toHttpsUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  return url.replace(/^http:\/\/api\.goadeals\.in/i, 'https://api.goadeals.in');
};

// Alias kept for existing imports
export const toHttpUrl = toHttpsUrl;

const rawBase = process.env.REACT_APP_API_URL || 'https://api.goadeals.in/api';
const API_BASE_URL = toHttpsUrl(rawBase);

/** Origin without /api — for uploads/images */
export const getApiOrigin = () => {
  const base = toHttpsUrl(process.env.REACT_APP_API_URL || 'https://api.goadeals.in');
  return base.replace(/\/api\/?$/, '');
};

/** Normalize any media/API URL to https for api.goadeals.in */
export const resolveMediaUrl = (url) => {
  if (!url) return url;
  if (typeof url !== 'string') return url;
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return toHttpsUrl(url);
  }
  const origin = getApiOrigin();
  if (url.startsWith('/')) return `${origin}${url}`;
  return `${origin}/uploads/images/${url}`;
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

api.interceptors.request.use(
  (config) => {
    console.log(`[API Request] ${config.method?.toUpperCase()} ${config.url}`);
    console.log('[API Base URL]', API_BASE_URL);
    return config;
  },
  (error) => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log(`[API Response] ${response.config.method?.toUpperCase()} ${response.config.url}`, response.status);
    return response;
  },
  (error) => {
    console.error('[API Error]', {
      message: error.message,
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
    });

    if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
      console.error('[CORS/Network Error] Check if backend server is running and CORS is configured correctly');
      console.error('[Backend URL]', API_BASE_URL);
    }

    return Promise.reject(error);
  }
);

export const hotelsAPI = {
  getAll: () => api.get('/hotels'),
  getFeatured: () => api.get('/hotels/featured'),
  getById: (id) => api.get(`/hotels/${id}`),
};

export const packagesAPI = {
  getAll: () => api.get('/packages'),
  getFeatured: () => api.get('/packages/featured'),
  getById: (id) => api.get(`/packages/${id}`),
};

export const activitiesAPI = {
  getAll: () => api.get('/activities'),
  getById: (id) => api.get(`/activities/${id}`),
};

export default api;
